import React from "react";
import ReactDOM from "react-dom";

import * as Sentry from "@sentry/react";

import { App } from "./features/app/components/App.web";
import { getLogger } from "./features/base/logging/functions";
import Platform from "./features/base/react/Platform.web";
import { getJitsiMeetGlobalNS, getJitsiMeetGlobalNSConnectionTimes } from "./features/base/util/helpers";
import DialInSummaryApp from "./features/invite/components/dial-in-summary/web/DialInSummaryApp";
import PrejoinApp from "./features/prejoin/components/web/PrejoinApp";
import WhiteboardApp from "./features/whiteboard/components/web/WhiteboardApp";

/**
 * Initialize Sentry
 */
Sentry.init({
    dsn: "https://75ebb7d58fb40a2168a05f5e6c276ba7@sentry.stinascloud.ir/15",
   sendDefaultPii: true,
});

const logger = getLogger("app:index.web");

/**
 * Send global JS errors to Sentry
 */
window.addEventListener("error", (ev) => {
    Sentry.captureException(ev.error);

    logger.error(
        `UnhandledError: ${ev.message}`,
        `Script: ${ev.filename}`,
        `Line: ${ev.lineno}`,
        `Column: ${ev.colno}`,
        "StackTrace: ",
        ev.error?.stack,
    );
});

window.addEventListener("unhandledrejection", (ev) => {
    Sentry.captureException(ev.reason);

    logger.error(`UnhandledPromiseRejection: ${ev.reason}`, "StackTrace: ", ev.reason?.stack);
});

// Workaround for the issue when returning to a page with the back button and
// the page is loaded from the 'back-forward' cache on iOS which causes nothing
// to be rendered.
if (Platform.OS === "ios") {
    window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
            window.location.reload();
        }
    });
}

const globalNS = getJitsiMeetGlobalNS();
const connectionTimes = getJitsiMeetGlobalNSConnectionTimes();

globalNS.hasLoaded = false;

connectionTimes["index.loaded"] = window.indexLoadedTime;

window.addEventListener("load", () => {
    connectionTimes["window.loaded"] = window.loadedEventTime;
    globalNS.hasLoaded = true;
});

document.addEventListener("DOMContentLoaded", () => {
    const now = window.performance.now();

    connectionTimes["document.ready"] = now;
    logger.log("(TIME) document ready:\t", now);
});

globalNS.entryPoints = {
    APP: App,
    PREJOIN: PrejoinApp,
    DIALIN: DialInSummaryApp,
    WHITEBOARD: WhiteboardApp,
};

globalNS.renderEntryPoint = ({ Component, props = {}, elementId = "react" }) => {
    /* eslint-disable-next-line react/no-deprecated */
    ReactDOM.render(
        <Sentry.ErrorBoundary fallback={"An error occurred"}>
            <Component {...props} />
        </Sentry.ErrorBoundary>,
        document.getElementById(elementId),
    );
};
